export default __webpack_public_path__ + "static/media/faqcat.8a0d9f3b.svg";